import { createContext, useContext } from 'react';

type PageContextType = {
  setTitle: (title: React.ReactNode) => void;
  setActions: (actions: React.ReactNode) => void;
};

export const PageContext = createContext<PageContextType>({
  setTitle: () => {},
  setActions: () => {},
});

export const usePage = () => useContext(PageContext);
